var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleTagManagerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.936,
    height: 21.939,
    viewBox: "0 0 21.936 21.939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google-Tag-Manager",
    transform: "translate(-447.813 -106.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51684",
    "data-name": "Path 51684",
    d: "M1351.509,1014.078l-3.809-3.813,8.182-8.265,3.879,3.878Z",
    transform: "translate(-890.818 -886.599)",
    fill: "#8ab4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51685",
    "data-name": "Path 51685",
    d: "M460.718,189.979l-3.878-3.879-8.223,8.223a2.74,2.74,0,0,0,0,3.876l0,0,8.223,8.223,3.8-3.822-6.214-6.335Z",
    transform: "translate(0 -78.922)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51686",
    "data-name": "Path 51686",
    d: "M1276.58,115.4l-8.223-8.223a2.743,2.743,0,1,0-3.879,3.878l8.228,8.223a2.742,2.742,0,1,0,3.878-3.878Z",
    transform: "translate(-807.64 0)",
    fill: "#8ab4f8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1486",
    "data-name": "Ellipse 1486",
    cx: 2.718,
    cy: 2.718,
    r: 2.718,
    transform: "translate(456.03 122.877)",
    fill: "#246fdb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTagManagerLogo);
export default __webpack_public_path__ + "static/media/google-tag-manager-logo.0ae17baf2f6d30dc6af2a5f000f3b6f7.svg";
export { ForwardRef as ReactComponent };